<template>
    <div v-if="modal.backdrop">
        <div
            class="modal fade"
            :class="modal.open ? 'show' : ''"
            style="display: block"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
            @click="$event.target.classList.contains('modal') ? close() : true"
        >
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{config.title}}</h5>
                        <button
                            type="button"
                            class="close"
                            @click="close"
                            v-html="loading ? spin() : ic('close')"
                        >
                        </button>
                    </div>
                    <form @submit.prevent="submit">
                        <div class="modal-body" ref="modal">
                            <div class="row form-group">
                                <div class="col-12">
                                    <label class="form-label">NIK</label>
                                    <input maxlength="16" @keypress="numberOnly($event)" class="form-control" placeholder="NIK" ref="focus"  v-model="input.nik" required>
                                </div>
                                <div class="col-6">
                                    <label class="form-label">Nama</label>
                                    <input type="text" class="form-control" placeholder="Nama lengkap" v-model="input.name" required>
                                </div>
                                <div class="col-6">
                                    <label class="form-label">Nama Panggilan</label>
                                    <input type="text" class="form-control" placeholder="Nama panggilan" v-model="input.final_name">
                                </div>
                            </div>

                            <div class="row form-group">
                                <div class="col-6">
                                    <label class="form-label">Email</label>
                                    <input type="email" class="form-control" placeholder="Email" autocomplete="off" v-model="input.email" required>
                                </div>

                                <div class="col-6">
                                    <label class="form-label">Nomor Telepon</label>
                                    <input type="tel" @keypress="numberOnly($event)" maxlength="13" class="form-control" placeholder="Nomor telepon" v-model="input.phone" required>
                                </div>
                            </div>

                            <div class="row form-group">
                                <div class="col-6" @click="_scrollTo('modal')">
                                    <label class="form-label">Perusahaan</label>
                                    <selectize 
                                        v-model="input.perusahaan"
                                        data-placeholder="Pilih Perusahaan" 
                                        :settings="selectizeConfig"
                                        @input="_getDepo($event
                                        )" required :disabled="loading"
                                    
                                    >
                                        <option :value="perusahaan.id" v-for="(perusahaan, index) in data.perusahaans" :key="index">
                                            {{perusahaan.kode_perusahaan}} - {{perusahaan.nama_perusahaan}}
                                        </option>
                                    </selectize>
                                </div>

                                <div class="col-6" @click="_scrollTo('modal')">
                                    <label class="form-label">Depo</label>
                                    <selectize data-placeholder="Pilih Depo"
                                    v-model="input.depo" :settings="selectizeConfig" required :disabled="loading">
                                        <option :value="depo.id" v-for="(depo, index) in data.depos" :key="index">{{depo.nama_depo}} - {{depo.perusahaan.kode_perusahaan}}</option>
                                    </selectize>
                                </div>
                            </div>


                            <div class="form-group">
                                <label for="" class="form-label">Password</label>
                                <input type="password" class="form-control" placeholder="Password" v-model="input.password" required>
                            </div>

                            <div class="form-group" >
                                <label for="" class="form-label">Konfirmasi Password</label>
                                <input type="password" class="form-control" placeholder="Konfirmasi password" v-model="input.password_confirmation" required>
                            </div>
                        </div>
                        
                        <div class="modal-footer pt-2">
                            <button type="button" class="btn btn-white" @click="close()" v-html="'Tutup'"></button>
                            <button 
                                type="submit"
                                class="btn btn-primary"
                                :disabled="isSubmit"
                                v-html="modal.isSubmit ? spin() : 'Simpan'">
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import {mapActions, mapState} from "vuex";

export default {
  name: "FormCreateDriver",
  props: {
    config: {
        view: false,
        title: "Modal Title"
    },
    isSubmit: {default: false},
    status: {default: false},
  },    
  mixins: [helper],
  data(){
    return{
        modal: {
            open: false,
            backdrop: false,
        },
        selectizeConfig: {
            maxItems: 99,
            plugins: ["remove_button"]
        },
        data:{
            perusahaans:[],
            depos:[]
        },
        input: {
            nik: '',
            name: null,
            final_name: null,
            email: null,
            phone: null,
            depo: [],
            perusahaan: [],
            status: 'active',
            password: null,
            password_confirmation: null,
        }
    }
  },
  computed: {
    ...mapState('perusahaan', ['perusahaans']),
    ...mapState(['loading'])
  },
  methods: {
    ...mapActions('perusahaan', ['getListPerusahaan','getDriverOptimize']),
    ...mapActions('depo', ['getListDepo']),

    submit(){
        if(this.input.password.length < 6){
          this.toast('Minimal password 6 karakter'); return
        }
        if(this.input.password !== this.input.password_confirmation){
            this.toast('Konfirmasi password salah'); return
        }
        this.$emit('update:isSubmit', true)
        this.$emit('submit', this.input);
    },  

    async _getPerusahaan(){
        const response = await this.getListPerusahaan()
        this.data.perusahaans = response.data
    },
    
    async _getDepo(ids_perusahaan){    
        if (typeof ids_perusahaan === 'undefined' || ids_perusahaan.length === 0) {
            this.data.depos = []
        } else {
            this.data.depos = await this.getListDepo({id_perusahaan: ids_perusahaan, filter: true})
        }
    },

    close(){
        this.$emit("update:config", { view: false, title:"Create Driver"});
    }
  },
  watch:{
    "config.view":function(view){
        if(view) {
            this.$emit("update:isSubmit", false);
            this.modal.backdrop = view;
            setTimeout(() => {
                this.modal.open = view;
                if(this.data.perusahaans.length == 0){
                    this._getPerusahaan()
                }
            },100)
        } else {
            this.modal.open = view;
            setTimeout(() => {
                this.modal.backdrop = view;
            }, 100);
        }
    },
    "status":function(status)
    {
        if(status)
        {
            this.input = {}
        }
    }
  }
}
</script>

